const STORAGE_KEY = 'trackiai_cookie_consent';

export type CookieConsentChoice = 'essential_only' | 'all';

export interface StoredConsent {
  choice: CookieConsentChoice;
  decidedAt: string;
}

/**
 * Read stored cookie consent, if any.
 */
export function getConsent(): StoredConsent | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as StoredConsent;
    if (parsed.choice !== 'essential_only' && parsed.choice !== 'all') return null;
    return parsed;
  } catch {
    return null;
  }
}

/**
 * Persist the user's cookie choice.
 */
export function setConsent(choice: CookieConsentChoice): void {
  const payload: StoredConsent = { choice, decidedAt: new Date().toISOString() };
  localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
}

/** True when the user has already accepted or declined optional cookies. */
export function hasDecided(): boolean {
  return getConsent() !== null;
}

/** True when analytics cookies are allowed. */
export function analyticsAllowed(): boolean {
  return getConsent()?.choice === 'all';
}
